module.exports = __webpack_public_path__ + "static/media/kind-logo.e4911a6a.svg";